import styled from '@emotion/styled';

import { CAROUSEL_CARD_HEIGHT } from '../../analytics-tab/carousel-card.styled';

export const CarouselRow = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing[16],
}));

export const CarouselViewport = styled('div')({
  flex: '1 1 auto',
  minWidth: 0,
  overflow: 'hidden',
});

export const SkeletonCard = styled('div')(({ theme }) => ({
  width: '100%',
  height: CAROUSEL_CARD_HEIGHT,
  padding: theme.spacing[16],
  borderRadius: theme.radius[16],
  backgroundColor: theme.colors.background.canvas,
  border: `1px solid ${theme.colors.border.default}`,
}));
